import React from 'react';
import Icon from '../../../components/AppIcon';

const CompanyBranding = () => {
  return (
    <div className="text-center mb-8">
      {/* Logo */}
      <div className="flex items-center justify-center mb-6">
        <div className="w-16 h-16 bg-primary rounded-2xl flex items-center justify-center shadow-lg">
          <Icon name="Brain" size={32} color="white" />
        </div>
      </div>

      {/* Company Name & Tagline */}
      <div className="space-y-2">
        <h1 className="text-3xl font-bold text-blue-700">C-success recruit</h1>
        <p className="text-lg text-muted-foreground">Intelligent Recruitment Platform</p>
        <p className="text-sm text-muted-foreground max-w-md mx-auto">
          Streamline your hiring process with AI-powered CV screening and comprehensive candidate management
        </p>
      </div>

      {/* Welcome Message */}
      <div className="mt-8 p-4 bg-primary/5 rounded-lg border border-primary/10">
        <h2 className="text-xl font-semibold text-foreground mb-2">Welcome Back</h2>
        <p className="text-sm text-muted-foreground">
          Sign in to access your recruitment dashboard and manage candidates efficiently
        </p>
      </div>
    </div>
  );
};

export default CompanyBranding;